import { Card, CardContent, Skeleton } from '@mui/material';
import { jsx, jsxs } from 'react/jsx-runtime';

// src/til/post-detail-page/content-skeleton.tsx
var SkeletonPostContent = () => /* @__PURE__ */ jsx(Card, { "aria-busy": "true", children: /* @__PURE__ */ jsxs(CardContent, { children: [
  /* @__PURE__ */ jsx(Skeleton, { variant: "text", width: "60%", height: 40, sx: { mb: 2 } }),
  /* @__PURE__ */ jsx(Skeleton, { variant: "text", width: "100%", height: 24, sx: { mb: 1 } }),
  /* @__PURE__ */ jsx(Skeleton, { variant: "text", width: "90%", height: 24, sx: { mb: 3 } }),
  /* @__PURE__ */ jsx(Skeleton, { variant: "rectangular", width: "100%", height: 200 })
] }) });

export { SkeletonPostContent };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-TYEUV553.mjs.map